// extracted by mini-css-extract-plugin
module.exports = {"flex":"FooterItemCollection_flex__9aa79","column":"FooterItemCollection_column__2e6c1","row":"FooterItemCollection_row__9c266"};